var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBorderCornerSmallRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 59,
  fill: "none",
  viewBox: "0 0 27 59"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#a)",
  strokeMiterlimit: 10,
  strokeWidth: 3.71,
  d: "M0 2h25v57"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 25.474,
  x2: 0,
  y1: 27.594,
  y2: 27.594,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})))));
export { SvgBorderCornerSmallRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNyIgaGVpZ2h0PSI1OSIgdmlld0JveD0iMCAwIDI3IDU5IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMCAySDI1VjU5IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl8zXzY5NikiIHN0cm9rZS13aWR0aD0iMy43MSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfM182OTYiIHgxPSIyNS40NzM5IiB5MT0iMjcuNTkzNyIgeDI9IjAiIHkyPSIyNy41OTM3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMyNkYwMjgiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDExRjIxIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KPC9zdmc+";